"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(state = {}, action) {
    var _a;
    switch (action.type) {
        case 'QUOTAFULL': {
            return Object.assign(Object.assign({}, state), { quotafull: true });
        }
        case 'SURVEY_SCREENOUT_SUCCESS': {
            return Object.assign(Object.assign({}, state), { screenout: true });
        }
        case 'SET_INTERVIEW_QUOTAS': {
            const quotaIds = (_a = action.data) === null || _a === void 0 ? void 0 : _a.quotaIds;
            return Object.assign(Object.assign({}, state), { quotaIds });
        }
        default: {
            return state;
        }
    }
}
exports.default = default_1;
